var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeathIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39.251,
    height: 34.747,
    viewBox: "0 0 49.251 54.747",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9079",
    "data-name": "Group 9079",
    transform: "matrix(0.259, -0.966, 0.966, 0.259, 0.609, 44.423)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_529",
    "data-name": "Path 529",
    d: "M34.3.643C33.258,2.726,32.192,4.8,31.243,6.927a18.339,18.339,0,0,0-.774,2.866l.188.058.7-1.468c0,1.195.01,2.186,0,3.175a.775.775,0,0,0,.469.818,12.179,12.179,0,0,1,1.833,1.107c1.128.843,2.226,1.727,3.308,2.626a3.742,3.742,0,0,1,.58.8l-6.553.261c1.089.551,2.1,1.02,3.076,1.564,1.886,1.054,3.615,2.291,4.307,4.484a23.436,23.436,0,0,1,.5,2.29c.006.029-.027.065-.044.1l-.4-.3c-.346.717-.644,1.418-1.007,2.081-2.15,3.917-6,5.795-9.663,8.085l.1-.595-4.305,1.64.528-.87H19.748l-.033-.135,1.212-.728-4.685-.267,0-.261.9-.163C9.887,33.217,5.158,29.552,3.765,22.039L4.8,23.213l.09-.092L4,21.369l.094-.05.644.855A7.469,7.469,0,0,0,4.167,20.5c-.97-2.3-1.176-4.779-1.679-7.188C1.3,7.584,35.948-2.665,34.3.643ZM0,8.951c.436,1.844.884,3.521,1.218,5.219C1.9,17.65,2.28,21.215,3.239,24.617a13.727,13.727,0,0,0,9.636,9.866c1.272.39,2.574.684,3.871.986a13.836,13.836,0,0,0,1.593.165l-.911.14a8.135,8.135,0,0,0,4.38,1.135l-.634.353a9.415,9.415,0,0,0,4.618-.546l-.515.615.077.119c.628-.263,1.262-.505,1.877-.791A31.822,31.822,0,0,0,35.4,31.6a10.766,10.766,0,0,0,3.346-4.877L39.163,28a2.825,2.825,0,0,0,.68-2.263,2.512,2.512,0,0,1,.9-2.47c.557-.582,1.231-1.051,1.831-1.593.669-.6,1.312-1.235,1.959-1.846l.742-1.963a1.166,1.166,0,0,0,.058-.684c-.069-.415-.2-.822-.3-1.233-.355.111-.707.232-1.064.327-.246.066-.634.225-.728.127l-1.222.657c-.968.061-1.721.121-2.474.144a.613.613,0,0,1-.461-.211,17.7,17.7,0,0,0-5.473-4.82.946.946,0,0,1-.4-.453c-.259-.784-.478-1.583-.709-2.376l.173-.09.142-2.424a10.725,10.725,0,0,1,.868-2.6",
    transform: "translate(0 0)",
    fill: "#fff",
    stroke: "#113252",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_530",
    "data-name": "Path 530",
    d: "M.03,13.308c.5,2.409.709,4.889,1.679,7.188a7.486,7.486,0,0,1,.576,1.679l-.645-.856-.094.05.887,1.752-.09.092L1.306,22.039C2.7,29.552,7.428,33.217,14.683,34.1l-.9.163,0,.261,4.685.267-1.212.728.033.136h4.343l-.528.87,4.3-1.64-.1.595c3.661-2.29,7.513-4.167,9.663-8.084.363-.663.661-1.364,1.007-2.082l.4.3c.017-.035.05-.071.044-.1a23.4,23.4,0,0,0-.5-2.29c-.692-2.194-2.422-3.431-4.307-4.484-.974-.544-1.988-1.014-3.077-1.565l6.553-.261a3.758,3.758,0,0,0-.58-.805c-1.083-.9-2.18-1.783-3.308-2.626a12.194,12.194,0,0,0-1.833-1.107.775.775,0,0,1-.469-.818c.014-.989,0-1.979,0-3.175l-.7,1.468-.188-.058a18.358,18.358,0,0,1,.774-2.866C29.733,4.8,30.8,2.727,31.84.643,33.49-2.665-1.163,7.584.03,13.308ZM20.285,6.216l.1-.2,2.351,1.256-.092.179c-.388-.181-.782-.35-1.162-.55C21.076,6.688,20.683,6.446,20.285,6.216Z",
    transform: "translate(2.459 0)",
    fill: "#113252"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_535",
    "data-name": "Path 535",
    d: "M1.537,0,0,.457C.246,1.105.619,1.03,1.537,0Z",
    transform: "translate(39.298 20.976)",
    fill: "#113252"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4507",
    "data-name": "Rectangle 4507",
    width: 1.651,
    height: 9.412,
    transform: "translate(28.707 20.455)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4508",
    "data-name": "Rectangle 4508",
    width: 1.729,
    height: 9.412,
    transform: "translate(24.827 26.026) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9911",
    "data-name": "Path 9911",
    d: "M4.614,6.068c.951-.839,1.856-1.652,2.78-2.447A6.075,6.075,0,0,0,9.868,0,9.582,9.582,0,0,1,4.985,1.176C3.333,1.145,1.683.947,0,.874,2.021,2.221,3.977,3.609,4.614,6.068ZM6.251,3.884C5.333,4.914,4.96,4.989,4.714,4.34Z",
    transform: "translate(34.584 17.092)",
    fill: "#113252"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeathIcon);
export default __webpack_public_path__ + "static/media/deathIcon.7d8f8b3a91425c20ab8b47e898f1e854.svg";
export { ForwardRef as ReactComponent };